import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ITenantState } from "./types";
import { getAllTenants } from "./thunks";
import { initialValues } from "../addEditTenant/intialValues";

const initialState: ITenantState = {
  tenantList: [],
  currentTenant: initialValues,
  isModalOpen: false,
  isSelectiveUpgradeModalOpen: false,
};

export const tenant = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    setTenantList: (state, action: PayloadAction<any>) => {
      state.tenantList = action.payload;
    },
    setCurrentTenant: (state, action: PayloadAction<any>) => {
      state.currentTenant = action.payload;
    },
    setIsModalOpen: (state, action: PayloadAction<any>) => {
      state.isModalOpen = action.payload;
    },
    setIsSelectiveUpgradeModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isSelectiveUpgradeModalOpen = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllTenants.fulfilled, (state, action) => {
      state.tenantList = action.payload;
    });
  },
});
export const { setTenantList, setCurrentTenant, setIsModalOpen, setIsSelectiveUpgradeModalOpen } = tenant.actions;
export default tenant.reducer;
